import { rgba } from 'emotion-rgba';
export const colors = {
  black: '#000',
  white: '#fff',
  primary: '#00378B',
  primaryHover: '#022B6B',
  secondary: '#F20000',
  secondaryHover: '#cf0000',
  green: '#26AE50',
  yellow: '#FAB234',
  orange: '#FFA500',
  darkYellow: '#E6AB38',
  primaryBgColor: '#0f0617',
  tuna: '#352a40',
  GrdContentBgTopColor: '#401A4C',
  AppBgColor: '#0F0617',
  AnchorTagColor: '#DA76FF',
  TemplateLoaderTrayBgDesktop: '#1A0C27',
  TemplateLoaderTrayBgLight: '#1C0B2B',
  TemplateLoaderTrayBgDark: '#170C20',
  TemplateLoaderAccent: '#352A40',
  LightPinkWhite: '#F9F4F7',
  Purple: '#8230C6',
  PurpleLight: '#a785ff',
  greyNeutral: '#A39AAB',
  greyDark: '#483d52',
  warningYellowColor: '#f2c94c',
  // PurpleDisable: rgba(130, 48, 198, 0.5), //#8230C6
  PurpleDark: '#5C1695',
  GrayC4: '#C4C4C4',
  TooltipBg: '#332B3A',
  ChannelCardBg: '#1d1424',
  ComboPackHover: '#FAE6F4',
  ComboCardGray: '#f4f4f4',
  LiveHighlight: '#F54949',
  ViWidgetBg: '#4d334b',
  BlueMagenta: ' #1B1223',
  ErrorInput: '#F24E1E',
  SidebarColor: '#1B1223',
  EduTrayStripBg: '#210D33',
  EduBlue: '#2F80ED',
  EduLightPurple: '#A875FF',
  PlanExpiryAlertTextColor: '#FD8282',
  subscriptionPoupBg: '#ECECEC',
  SearchCardBg: '#1D1425',
  SearchFilterDesktopBg: '#271F2E',
  SearchFilterDropdownBg: '#11051C',
  NewSubscriptionBorder: '#2C2136',
  NewSubscriptionCouponText: '#F2F2F2',
  NewSubscriptionColumnActive: '#C1AAFF',
  greyText: '#BDBDBD',
  AccentDarkGrayColor: '#333333',
  Grey800: '#4f4f4f',
  PurpleCl: '#8330C6',
  Gray4F: '#4f4f4f', //#4f4f4f
  GrayD8: '#d8d8d8', //#d8d8d8
  AmethystSmoke: '#938f97',
  Lavender: '#A785FF',
  TransparentSmoke: '#FFFFFF80',
  Transparent: 'transparent',
  VioletRed: '#8330c6',

  // hlsa color
  HlsaBlackColor: 'hsla(0, 0%, 100%, 0.2)',
  // Accent colors
  // AccentRoseColorAlpha: rgba(178, 5, 162, 0.3); // #B205A2
  // AccentRoseColor: rgba(137, 124, 138, 1); // #
  AccentLighterGrayColor: '#999999',
  AccentCodGrayColor: '#171717',
  AccentDustyGrayColor: rgba('#9C9C9C', 0.1),
  AccentCodGrayFaqBgColor: rgba('#9C9C9C', 0.17), // #9C9C9C
  AccentLoulouColor: '#4B1132',
  AccentHeaderColor: '#2C0B2D',
  AccentLightGrayColor: '#5E5E5E',
  AccentScrollBarBg: rgba('#d8d8d8', 0.2),
  AccentScrollBarTrack: rgba('#d8d8d8', 0.45),
  AccentScrollBar: rgba('#d8d8d8', 0.5),
  AccentTrayBgGrayColor: '#1E1E1E',
  AccentPopupColor: '#2e0130',
  AccentPopupLinkColor: '#bf006b',
  ErrorColor: '#e50045',
  SubscribeIconColor: '#ffd3e2',
  ProfileTabColor: '#2a182b',
  ProfileContentColor: '#201321',
  ProfileTitleBorderColor: rgba('#7a7a7a', 0.2),
  ProfileMyPlanGrdFirst: '#1b0c1d',
  ProfileMyPlanGrdSecond: '#0a060a',
  DropdownSelectedColor: '#efefef',
  AccentSubscriptionCard: '#b205a2',
  AccentSubscriptionCodeSuccessColor: '#78a942',
  AccentSubscriptionCodeCancelColor: '#e10181',
  AccentSubscriptionCodeFailureColor: '#d61c1c',
  AccentSubscriptionPromoInputBgColor: '#271028',
  AccentSubscriptionDiscountColor: '#9b9b9b',
  BurgerMenuDeskColor: '#1d001d',
  FilterSortColor: '#8e808e',
  NavMenuTextColor: '#cfc3ca',
  GrdBgMatching: '#20011d',
  AccentWarmGreyColor: '#979797',
  RadioCheckBorderColor: '#999999',
  MoreMenuHighlight: rgba('#ff0091', 0.16),
  plexDurationCountdown: rgba('#efb404', 0.8),
  plexHeaderBorderColor: '#E0E0E0',
  SubscriptionCheckboxGreenColor: '#1BB934',
  SubscriptionBadgeBlueColor: '#2F7FEB',
  AccentPromoCodeSuccessColor: '#219653',
  AccentPromoCodeFailureColor: '#eb5757',
  AccentSubscriptionCodGrayColor: '#BDBDBD',
  AccentInfoPopupDescriptionMobileColor: '#828282',
  AccentInfoPopupDescriptionDesktopColor: '#666666',
  Grey88: '#E0E0E0',
  SubscriptionLightBg: '#F5F5F5',
  PurpleBtn: '#8230C6',
  PurpleBtnHover: '#68269E',
  CollectionCard1Color: '#60279F',
  CollectionCard2Color: '#170E40',
  ComboPopupSubtitleGray: '#4F4F4F',
  ComboPopupBtnPink: '#D62091',
  AccentShowDetailsInfoBg: '#191020',
  AccentMyAccountMenuHoverColor: '#C1C1C1',
  inputError: '#EB5757',
  episodeCountColor: '#a39aab',
  LightPurpleColor: '#4E4456',
  Pink: '#b82e8a',
  PinkHover: '#a3297a',
  ToastMsg: '#8C00FF',
  DarkPurple: '#26103a',

  // Player
  PlayerVolumeBarBg: '#424242',
  PlayerRose: '#ff0091',
  PlayerSettingsBg: rgba('#060107', 0.8),

  // Primary colors
  PrimaryWhiteColor: '#FFFFFF',
  PrimaryWhiteColorAlpha: '#525252',
  PrimaryWhiteColorAlpha90: rgba('#FFFFFF', 0.9),
  PrimaryWhiteColorAlpha80: rgba('#FFFFFF', 0.8),
  PrimaryWhiteColorAlpha70: rgba('#FFFFFF', 0.7),
  PrimaryWhiteColorAlpha60: rgba('#FFFFFF', 0.6),
  PrimaryWhiteColorAlpha50: rgba('#FFFFFF', 0.5),
  PrimaryWhiteColorAlpha40: rgba('#FFFFFF', 0.4),
  PrimaryWhiteColorAlpha35: rgba('#FFFFFF', 0.35),
  PrimaryWhiteColorAlpha30: rgba('#FFFFFF', 0.3),
  PrimaryWhiteColorAlpha20: rgba('#FFFFFF', 0.2),
  PrimaryWhiteColorAlpha15: rgba('#FFFFFF', 0.15),
  PrimaryWhiteColorAlpha16: rgba('#FFFFFF', 0.16),
  PrimaryWhiteColorAlpha10: rgba('#FFFFFF', 0.1),
  PrimaryWhiteColorAlpha11: rgba('#FFFFFF', 0.11),
  PrimaryWhiteColorAlpha09: rgba('#FFFFFF', 0.09),
  PrimaryWhiteColorAlpha08: rgba('#FFFFFF', 0.08),
  PrimaryWhiteColorAlpha06: rgba('#FFFFFF', 0.06),
  PrimaryWhiteColorAlpha05: rgba('#FFFFFF', 0.05),
  PrimaryWhiteColorAlpha04: rgba('#FFFFFF', 0.04),
  PrimaryWhiteColorAlpha03: rgba('#FFFFFF', 0.03),
  PrimaryWhiteColorAlpha01: rgba('#FFFFFF', 0.01),

  PrimaryWhiteColorAlpha0: rgba('#FFFFFF', 0),
  PrimaryGreyColor: '#333',
  PrimaryGreyColorAlpha0: '#bdbdbd',
  PrimaryBlackColorAlpha60: rgba('#000000', 0.6),
  PrimaryBlackColorAlpha20: rgba('#000000', 0.2),
  PurpleAlpha0: rgba('#27103B', 0),
  GrayColor4A: rgba('#4F4F4F', 1), //#4F4F4F,
  DarkGrayColor: rgba('#E6E6E6', 1),
  LightGrayColor: rgba('#B4B4B4', 1),
  TintedNeutral: '#E6E2E8',
  PrimaryBlackColor: rgba('#000000', 1),

  // search colors
  ErrorIconColor: '#9c5a5a',
  ErrorIconBackgroundColor: '#ffdf6d',
  DialogContentBackgroundColor: '#0e0616',
  RecentSearchListOnHover: '#300057',
  // Subscription Page
  SubscriptionPlansBorderBottom: '#2c2136 ',

  // Login Popup
  GrayAlbhaPoint36: 'rgba(51, 51, 51, 0.36)',
  GrayAlbhaPoint54: 'rgba(51, 51, 51, 0.54)',
  InputBorder: '#bdbdbd',

  //Portal color
  PortalTransparentBg: rgba('#000000', 0.8),

  //ProfileMenu color
  ProfileHeaderBg: '#e1e1e10f',
  // Gradient
  GradientOceanBlue: '#5730c7',
  GradientHanPurple: '#5c2ade',
  GradientPalatinateBlue: '#2928D4',
  SpaceGrey: '#1D001E',
  CharlestonGreen: '#2c2531',

  TvodCardBackground: '#3c123e',
  TvodHeaderGray: '#c9c0c7',
  NewOptionOrange: '#ff971d',
  MobileHamburgerBackgroundPurple: '#1d1525',
  LottiRedAlpha18: 'rgba(231, 0, 66, 0.18)',
  KinkyKoalaAlpha18: 'rgba(183, 0, 198, 0.18)',
  LavenderAura: '#A39AAB',
  MacaroniAndCheese: '#FFC177',
  TintedGrey30: '#C9C3CF',
  TintedGrey50: '#786D80',
  Gray: '#303030',
  PinScoreCardBg: 'var(--color-black-black-24, rgba(0, 0, 0, 0.24))',
  OnHoverPinScoreCardBg:
    'var(--color-white-white-24, rgba(255, 255, 255, 0.24))',
  liveDotColor: 'var(--Secondary-Error, #eb5757)',
  PinScoreCardText: '#e6e6e6',
  YellowGold: '#DBC776',
  LavendarLight: '#C297E5',
  TagGray: '#4B494D',
  TagGreen: '#ADC630',
  PlanCardGray: '#333035',
  SubscriptionGrey: '#251e2b',
  BorderGrey: '#574f5a',
  FeatureGrey: '#A69CAD',
  PlanTitleGrey: '#E4DDEB',
  PlanContainer: '#554d6f',
  DarkSlate: '#1F1F1F',
  DustyMauve: '#665a70',
  DeepCharcoal: '#0f0b0b'
};
